import React, {
  useEffect,
  useMemo,
  useState,
  useCallback,
  useContext,
} from "react";
import { useSelector, useDispatch } from "react-redux";
// import { getConsumptions } from '../redux/actions/profileActions';
import {
  Col,
  Row,
  Container,
  ListGroup,
  ListGroupItem,
  Collapse,
  Button,
  Card,
  Tabs,
  Tab,
  Badge,
  Modal,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronUp,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import { format } from "date-fns";
import { es, enUS } from "date-fns/locale";
import {
  currencyFormat,
  formatDate,
  invertDate,
  formatDateFromLanguage,
} from "../functions";
import { serviceTypeName } from "../i18n";
import { Link, NavLink } from "react-router-dom";
import { T } from "react-translator-component";
import { i18nValue } from "../functions";
import Screen from "../components/Screen";
import { HotelContext } from "../context/hotel";
import { useLanguage } from "../hooks/useLanguage";
import { UserContext } from "../context/user";
import PayButton from "../components/PayButton";

const Account = () => {
  const [showModal, setShowModal] = useState(false);
  // const dispatch = useDispatch()
  // const { sections, data : { code : hotelCode } } = useSelector(state => state.hotelReducer);
  const { sectionsByCode, getUrlPath, currency } = useContext(HotelContext);
  const { Room, RoomOccupation, refreshBalanceAndInvoices, language } =
    useContext(UserContext);

  const consumptions = []; // TODOD::::
  const pricePerDay = 900; // TODOOO
  const passengers = []; // TODOOOO

  // const { checkIn : { passengers } } = useSelector(state => state.checkInReducer);
  // const { consumptions, dateStart, dateEnd, checkOutDate, pricePerDay, totalDays, Room } = useSelector(state => state.profileReducer);

  // let checkIn = new Date(dateStart + ' GMT-0300')     // TODO::: mejorar esto
  // let checkOut = new Date();
  // if (checkOut.getHours() >= 12) {
  //   checkOut = new Date(Date.now() + (3600 * 1000 * 24));
  // }
  // checkOut.setHours(12,0,0,0)

  useEffect(() => {
    refreshBalanceAndInvoices();
  }, []);

  const RoomCategoryName = useMemo(() => {
    return Room ? Room.name : "-";
  }, [Room]);

  // const stay = useMemo(() => {
  //   const checkOutDate = null; // TODOOOOO
  //   const totalDays = 3; // TODODOOOO

  //   if (!RoomOccupation) return { days: 0, percent: 0 };
  //   const checkOut = new Date(
  //     !checkOutDate ? RoomOccupation.end : checkOutDate
  //   );
  //   const checkIn = new Date(RoomOccupation.start);
  //   const _days = !totalDays
  //     ? Math.trunc((checkOut - checkIn) / (1000 * 3600 * 24))
  //     : totalDays;
  //   const _stayed = Math.ceil((new Date() - checkIn) / (1000 * 3600 * 24));
  //   return {
  //     days: _days,
  //     stayed: _stayed,
  //     percent: (_stayed * 100) / _days,
  //   };
  // }, [RoomOccupation]);

  const showBalance = useMemo(() => {
    return RoomOccupation?.showBalance ?? false;
  }, [RoomOccupation?.showBalance]);

  const _getTranslate = (group, value) => {
    // const _key = (slugify(group) + '.' + slugify(value)).toUpperCase();
    // let _newValue = intl.formatMessage({ id: _key });
    // console.log('1106 - _newValue', _newValue)
    // if (_newValue !== _key) {
    //   return _newValue;
    // }
    return value;
  };

  // console.log('2906 - format', format('2023-06-29T13:38:58.250588Z', '', { locale: es }))

  const balance = useMemo(() => {
    if (!RoomOccupation?.balance) return false;

    console.log('7oct - RoomOccupation.balance', RoomOccupation.balance);

    const _balance = RoomOccupation.balance;
    // if (typeof _balance === "string") {
    //   _balance = JSON.parse(_balance);
    // }
    if (_balance) {
      const r = { total: _balance.total };
      // r['total'] = _balance.total ?? 0;
      // r['charges'] = _balance.charges ?? [];
      // r['payments'] = _balance.payments ?? [];
      // r['allowances'] = _balance.allowances ?? [];
      if (_balance?.charges && _balance.charges.length > 0) {
        const _order = { Accommodation: 1, FoodAndBeverages: 5, Other: 10 };
        r["charges"] = { total: 0, items: {} };
        _balance.charges.map((i) => {
          if (r["charges"]["items"][i.type] === undefined) {
            r["charges"]["items"][i.type] = {
              type: i.type,
              name: _getTranslate("charges", i.type),
              desc: false,
              items: [],
              order: _order[i.type] ?? 50,
              qty: 0,
              amount: 0,
            };
          }
          r["charges"]["items"][i.type]["qty"] += i.qty;
          if (i.items?.length > 0) {
            if (i.type !== "Accommodation") {
              i.items.map((item) =>
                r["charges"]["items"][i.type]["items"].push(
                  `${formatDateFromLanguage(item.date, language)} - ${item.name ?? ""
                  } ${currencyFormat(item.amount * -1)}`
                )
              );
            } else {
              i.items.map((item) =>
                r["charges"]["items"][i.type]["items"].push(item.name)
              );
            }
          }
          r["charges"]["items"][i.type]["amount"] += i.amount;

          r["charges"]["total"] += i.amount;
        });
        r["charges"]["items"]["Accommodation"]["desc"] = "desc"; // intl.formatMessage({ id: 'CHARGES.ACCOMMODATION_DESCRIPTION'}, { qty: r['charges']['items']['Accommodation']['items'].length, room_type: r['charges']['items']['Accommodation']['items'][0] });
        delete r["charges"]["items"]["Accommodation"]["items"];

        r["charges"]["items"] = Object.values(r["charges"]["items"]).sort(
          (a, b) => a.order - b.order
        );
      }
      if (_balance?.payments && _balance.payments.length > 0) {
        r["payments"] = { total: 0, items: _balance.payments };
        _balance.payments.map((i) => {
          i["date"] = `${i.date}`;
          i["method"] = _getTranslate("payments", i.method);
          r["payments"]["total"] += i.amount;
        });
      }
      console.log("balance result", r);
      return r;
    }

    return false;

    // const _r = { charges: { total: 0, items: [] }, payments: [], allowances: [], total: 0 }
    // if (!RoomOccupation?.balance) return _r;

    // const _data = JSON.parse(RoomOccupation.balance);
    // _r.charges = {
    //   total: _data.charges.reduce((tot, i) => tot + i.amount, 0),
    //   items: _data.charges
    // }
    // _r.payments = {
    //   total: _data.payments.reduce((tot, i) => tot + i.amount, 0),
    //   items: _data.payments
    // }
    // _r.total = _data.total
    // return _r
  }, [RoomOccupation?.balance]);

  const invoices = useMemo(() => {
    if (!RoomOccupation?.invoices) return null;

    return JSON.parse(RoomOccupation.invoices);
  }, [RoomOccupation?.invoices]);

  const title = i18nValue(sectionsByCode["account"], "title", language) || "Account";

  // const consumptionDetailed = useMemo(() => {
  //   const _r = {
  //     spents: {
  //       total: 0,
  //       items: []
  //     },
  //     payments: {
  //       total: 0,
  //       items: []
  //     }
  //   };
  //   if (consumptions) {
  //     consumptions.map(r => {
  //       if (r.price >= 0) {
  //         _r.spents.total += r.price
  //         _r.spents.items.push(r)
  //       } else {
  //         _r.payments.total += r.price
  //         _r.payments.items.push(r)
  //       }
  //     })
  //   }
  //   return _r;
  // }, [consumptions])

  // const totalAccommodation = useMemo(() => {
  //   if (stay.days && pricePerDay) {
  //     return stay.days * pricePerDay
  //   }
  //   return 0
  // }, [pricePerDay, stay]);

  // const totalConsumptions = useMemo(() => {
  //   let _tot = 0;
  //   if (consumptions)
  //     consumptions.map(r => _tot += r.price)
  //   return _tot;
  // }, [consumptions]);

  // const totalFinal = useMemo(() => {
  //   let _tot = 0;
  //   if (totalAccommodation) {
  //     _tot += totalAccommodation
  //   }
  //   if (totalConsumptions) {
  //     _tot += totalConsumptions
  //   }
  //   return _tot;
  // }, [totalConsumptions, totalAccommodation]);

  // const days = useMemo(() => {
  //   return Math.trunc((checkOut - checkIn) / (1000 * 3600 * 24));
  // }, [checkOut, checkIn])

  // useEffect(() => {
  //   dispatch(getConsumptions());
  // }, []);

  const showName = useCallback((name) => {
    let res = name;
    const key = `account.${name.toLowerCase()}`;
    if (T(key) != key) {
      res = T(key);
    }
    return res;
  }, [balance.charges?.items]);

  if (!passengers) {
    return (
      <>
        <p>Error 403</p>
        <Link to={getUrlPath("")}>Ir a Inicio</Link>
      </>
    );
  }

  return (
    <Screen
      section="account"
      title={title}
      description={i18nValue(sectionsByCode["account"], "desc", language)}
    >
      {showBalance && <Row className="page-body pt-4">
        <Col>
          <ListGroup className="list-group-flush shadow mb-3">
            {/* <ListGroupItem key={`accommodation`}>
                  <span className="general-data float-right detail-price">{currencyFormat(totalAccommodation)}</span>
                  <p className="general-text-bold mb-0 detail-title">{T('account.stay')}</p>
                  <p className="general-text mb-0 detail-description">{T('account.room')} {RoomCategoryName}, {stay.days} días a {currencyFormat(pricePerDay)} la noche</p>
                  <Collapse in={showAccomodationDetail}>
                    <Card border="default" bg="light" className="mt-3 mb-2">
                      <Card.Body className="p-2">
                          <h6>{passengers.length} {T('account.guest')}{passengers.length > 1 ? 's' : ''}</h6>
                          {passengers.map(p => {
                            return <p className="mb-0"><b>{p.surname}</b>, {p.name}. <small>{p.age} años. {p.dniType} {p.dni}</small></p>
                          })}
                      </Card.Body>
                    </Card>
                  </Collapse>
                  <Button size={'sm'} variant={'link'} type={'button'}
                      style={{ border: 'none', color: '#333', fontWeight: 400, textDecoration: 'none', fontSize: 14, paddingLeft: 0 }}
                      onClick={() => setShowAccomodationDetail(!showAccomodationDetail)}><FontAwesomeIcon size="sm" icon={ !showAccomodationDetail ? faChevronDown : faChevronUp } color="#999" className="mr-2"/>{!showAccomodationDetail ? T('account.more-info') : 'Ocultar Detalle'}</Button>
                </ListGroupItem> */}

            {/* {consumptions && consumptions.length > 0 && <ListGroupItem key={`consumptions`}>
                    <span className="general-data float-right">{currencyFormat(totalConsumptions)}</span>
                    <p className="general-text-bold mb-0">Consumos y Adicionales</p>
                    <p className="general-text mb-0">{consumptions.length} pedido{consumptions.length > 1 ? 's' : ''}</p>
                </ListGroupItem>} */}
            {/* {consumptionDetailed && consumptionDetailed.spents && consumptionDetailed.spents.items.length > 0 && <ListGroupItem key={`spents`}>
                    <span className="general-data float-right detail-price">{currencyFormat(consumptionDetailed.spents.total)}</span>
                    <p className="general-text-bold mb-0 detail-title">Consumos y Adicionales</p>
                    <p className="general-text mb-0 detail-description">{consumptionDetailed.spents.items.length} registro{consumptionDetailed.spents.items.length > 1 ? 's' : ''}</p>
                    <Collapse in={showConsumptionsList}>
                      <Card border="default" bg="light" className="mt-3 mb-2">
                        <Card.Body className="p-1">
                          
                          {consumptions && consumptions.map(c => {
                            let price = c.price;
                            const _updatedDate = Date.parse(c.updatedAt);
                            const updatedAtFormatted = formatDistanceToNow(_updatedDate, { addSuffix: true, locale: es });
                            return (<div key={`consumption-${c.id}`} className="account-item-row card-generic mb-1 shadow-sm">
                              <span className="general-data float-right" style={{ fontSize: 14, fontWeight: 600, lineHeight: '30px' }}>{currencyFormat(price)}</span>
                              <small style={{ fontSize: 12, fontWeight: 200 }}>{updatedAtFormatted}</small>
                              <p className="mb-0" style={{ fontSize: 14, fontWeight: 600 }}>{serviceTypeName(c.concept)}</p>
                              <p className="mb-0" style={{ fontSize: 12, fontWeight: 200 }}>
                                {c.Request && c.Request.cart && c.Request.cart.map(i => {
                                  return <p className="mb-0">{i.qty}x {i.desc}</p>
                                })}
                              </p>
                            </div>)
                          })}
                          
                        </Card.Body>
                      </Card>
                    </Collapse>
                    <Button size={'sm'} variant={'link'} type={'button'} style={{ border: 'none', color: '#333', fontWeight: 400, textDecoration: 'none', fontSize: 14, paddingLeft: 0 }} onClick={() => setShowConsumptionsList(!showConsumptionsList)}><FontAwesomeIcon size="sm" icon={ !showConsumptionsList ? faChevronDown : faChevronUp } color="#999" className="mr-2"/>{!showConsumptionsList ? T('account.more-info') : 'Ocultar Detalle'}</Button>
                </ListGroupItem>}
                {consumptionDetailed && consumptionDetailed.payments && consumptionDetailed.payments.items.length > 0 && <ListGroupItem key={`spents`}>
                    <span className="general-data float-right detail-price">{currencyFormat(consumptionDetailed.payments.total)}</span>
                    <p className="general-text-bold mb-0 detail-title">Pagos o Bonificaciones</p>
                    <p className="general-text mb-0 detail-description">{consumptionDetailed.payments.items.length} registro{consumptionDetailed.payments.items.length > 1 ? 's' : ''}</p>
                </ListGroupItem>} */}

            <ListGroupItem key={`total`} className="bg-light">
              <span
                className="general-data float-right"
                style={{
                  lineHeight: "30px",
                  fontWeight: "bold",
                  fontSize: "1.2rem",
                }}
              >
                {currencyFormat(balance.total, currency)}
              </span>
              <p
                className="mb-0"
                style={{
                  lineHeight: "30px",
                  fontWeight: "bold",
                  fontSize: "1.2rem",
                }}
              >
                {T("account.balance")}
              </p>
            </ListGroupItem>

            {balance && balance.charges?.total > 0 && (
              <ListGroupItem key={`charges`}>
                <span className="general-data float-right detail-price">
                  {currencyFormat(balance.charges.total * -1, currency)}
                </span>
                <p className="general-text-bold mb-0 detail-title">
                  {T("account.charges")}
                </p>

                {balance &&
                  balance.charges?.items &&
                  Object.keys(balance.charges.items).map((key) => {
                    const i = balance.charges.items[key];
                    return (
                      <div
                        className="d-flex align-items-top pt-1 pb-1 font-size-sm"
                        style={{ borderTop: "1px dotted #F2F2F2" }}
                        key={key}
                      >
                        <div className="d-flex flex-column flex-grow-1 ml-2">
                          <p
                            className={
                              "mb-0 font-size-sm text-dark-75 font-weight-bold"
                            }
                          >
                            {i.qty > 0 && (
                              <span className="font-weight-light">
                                {i.qty}x
                              </span>
                            )}{" "}
                            {showName(i.name)}
                          </p>
                          {i.desc && (
                            <p className={"mb-0 font-size-sm text-dark-75"}>
                              {i.qty}x{" "}{T(`account.${i.type.toLowerCase()}_description`)}
                            </p>
                          )}
                          {i.items?.length > 0 &&
                            i.items.map((item) => (
                              <small className={"text-dark-75"} key={item}>
                                {item}
                              </small>
                            ))}
                        </div>
                        <div className="d-flex align-items-top">
                          <div className="d-flex flex-column text-right">
                            <span className={"flex-nowrap text-dark-75"}>
                              {currencyFormat(i.amount * -1, currency)}
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </ListGroupItem>
            )}

            {balance && balance.payments?.total > 0 && (
              <ListGroupItem key={`payments`}>
                <span className="general-data float-right detail-price">
                  {currencyFormat(balance.payments.total, currency)}
                </span>
                <p className="general-text-bold mb-0 detail-title">
                  {T("account.payments")}
                </p>

                {balance.payments.items.map((p) => {
                  // const updatedAtFormatted = '09-09-2022' //formatDistanceToNow(_updatedDate, { addSuffix: true, locale: es });
                  return (
                    <div
                      className="d-flex align-items-top pt-1 pb-1 font-size-sm"
                      style={{ borderTop: "1px dotted #F2F2F2" }}
                      key={p.id}
                    >
                      <div className="d-flex flex-column flex-grow-1 ml-2">
                        <p className="mb-0 font-size-sm text-dark-75 font-weight-bold">
                          {p.method}
                        </p>
                        <p className="mb-0 font-size-sm text-dark-75">
                          {format(new Date(p.date), T("general.dateformat"))} -{" "}
                          {format(new Date(p.date), "hh:mm")}. {p.receipt}
                        </p>
                      </div>
                      <div className="d-flex align-items-top">
                        <div className="d-flex flex-column text-right">
                          <span className="flex-nowrap text-dark-75">
                            {currencyFormat(p.amount, currency)}
                          </span>
                          {/* i.amount < 0 ? 'text-danger' : 'text-dark-75' */}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </ListGroupItem>
            )}
          </ListGroup>

          {invoices && (
            <ListGroup className="list-group-flush shadow">
              <ListGroupItem key={`invoices`} className="bg-light">
                <p
                  className="mb-0"
                  style={{
                    lineHeight: "30px",
                    fontWeight: "bold",
                    fontSize: "1.2rem",
                  }}
                >
                  {T("account.invoices")}
                </p>
              </ListGroupItem>
              {invoices.map((row, idx) => {
                return (
                  <ListGroupItem key={`invoice-${idx}`}>
                    <span className="general-data float-right detail-price text-right">
                      {row.subTotal.amount} {row.subTotal.currency}
                      <br />
                      {row.outstandingPayment && (
                        <small className="text-danger">
                          -{row.outstandingPayment.amount}{" "}
                          {row.outstandingPayment.currency}
                        </small>
                      )}
                      {row.file && (
                        <div>
                          <a href={row.file} target="apaleoInvoice">
                            {T("account.download")}
                          </a>
                        </div>
                      )}
                    </span>
                    <p className="general-text-bold mb-0 detail-title">
                      <small>
                        {format(new Date(row.created), T("general.dateformat"))}{" "}
                        - {format(new Date(row.created), "hh:mm")}
                      </small>
                      <br />
                      {row.number}
                      <br />
                      {row.guestName}
                      <br />
                    </p>
                  </ListGroupItem>
                );
              })}
            </ListGroup>
          )}

          <ListGroupItem className="list-group-flush shadow">
            <p className="mb-0"
              style={{
                lineHeight: "30px",
                fontWeight: "light",
                fontSize: "0.9rem",
                textAlign: "justify",
                margin: "4px"
              }}>{T("account.chat")}</p>

            <div className="pr-2 pl-2">
              <NavLink to="../services/service_general">
                <Button
                  size={"lg"}
                  variant={"primary"}
                  type={"button"}
                  className="text-uppercase w-100 text-center mt-4"
                >
                  {T("general.chat")}
                </Button>
              </NavLink>
            </div>
            <PayButton balance={balance} />
          </ListGroupItem>
        </Col>
      </Row>}
    </Screen >
  );
};

export default Account;
